var map = {
	"./": 61,
	"./attachments": 125,
	"./attachments.js": 125,
	"./dialogs": 126,
	"./dialogs.js": 126,
	"./index": 61,
	"./index.js": 61,
	"./user": 127,
	"./user.js": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;